// extracted by mini-css-extract-plugin
export default {"sessionName":"DashboardSessionCard_sessionName__eaUp6"};